import {
  Box,
} from '@mui/material';


// Tab Panel
function TabPanel({ children, value, index }) {
  return value === index ? <Box sx={{ pt: 3 }}>{children}</Box> : null;
}

export default TabPanel;
